module.exports = __webpack_public_path__ + "img/newyear_reel_footer.70c47b60.jpg";